import React from 'react'

import styled from 'styled-components'

import { style } from 'theme'

import { Stats, StatsProps } from './Stats'

type StatsBarProps = {
  stats: StatsProps[]
  className?: string
}

const StatsBarContainer = styled.div<{ length: number }>`
  display: grid;
  row-gap: 20px;
  column-gap: 20px;
  grid-template-columns: repeat(${(props) => props.length}, 1fr);

  @media screen and (min-width: ${style(
      (theme) => theme.breakpoints.sm + 1,
    )}px) {
    background-color: ${style((theme) => theme.colors.ivoryLight)};
    padding: 20px;
    border-radius: 10px;
  }

  @media screen and (max-width: ${style((theme) => theme.breakpoints.sm)}px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const StatsBar = ({ stats, className }: StatsBarProps) => {
  return (
    <StatsBarContainer className={className} length={stats.length}>
      {stats.map((statsData, index) => {
        return <Stats {...statsData} key={`stats-field-${index}`} />
      })}
    </StatsBarContainer>
  )
}
